
        import Symbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-rescls-ogcfserver_service",
  "use": "icon-rescls-ogcfserver_service-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"icon-rescls-ogcfserver_service\"><g clip-path=\"url(#icon-rescls-ogcfserver_service_a)\"><path fill=\"#00B77E\" d=\"M6.5 13.5v-4C6.5 8 9 8 9 7l.076-.546H12L5.95 0 0 6.454h3.025v7.059z\" /><path fill=\"#106a90\" d=\"m7.318 9 4.35-1.78L15.98 9l-4.311 1.622zM11.906 10.957 16 9.455v4.943L11.907 16zM11.412 10.957 7.32 9.455v4.943L11.412 16z\" /></g><defs><clipPath id=\"icon-rescls-ogcfserver_service_a\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\" /></clipPath></defs></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-rescls-ogcfserver_service"/>
                </svg>
            );
        };

        Icon.id = "icon-rescls-ogcfserver_service";

        export default Icon;
    